import type { ChatStep } from '../../../types/stream.types';

export type ChatStepSegment =
  | { kind: 'prose'; steps: ChatStep[] }
  | { kind: 'activity'; steps: ChatStep[] };

export function filterRelevantChatSteps(steps: ChatStep[] | undefined): ChatStep[] {
  return (
    steps?.filter((s) => {
      if (s.type === 'thought') {
        return !!(s.message && s.message.trim());
      }
      if (s.type === 'tool_call') {
        return true;
      }
      if (s.type === 'text_output') {
        return !!(s.message && s.message.trim());
      }
      return false;
    }) ?? []
  );
}

export function partitionChatStepsIntoSegments(steps: ChatStep[]): ChatStepSegment[] {
  const segments: ChatStepSegment[] = [];
  for (const step of steps) {
    const kind = step.type === 'text_output' ? 'prose' : 'activity';
    const last = segments[segments.length - 1];
    if (last?.kind === kind) {
      last.steps.push(step);
    } else {
      segments.push({ kind, steps: [step] });
    }
  }
  return segments;
}

export function mergeProseMessages(segmentSteps: ChatStep[]): string {
  return segmentSteps.map((s) => s.message ?? '').join('');
}
